import { AcPortfolioLibraryRcs, CmaRcs, IqRcs, NileRcs, PaRcs, PiRcs, SharedRcs, TaxRcs } from '../enums/wwe-rcs.enum';
import { DataServiceApiUtil } from '../utils/data-service-api.util';

export class DataServiceApiConstants {
	public static readonly CONFIG_VENDOR_VIEW_ID = 'modelPortfolio@blackrock';

	public static readonly AS_OF_DATE_TYPES = {
		LATEST: 'LATEST',
		APPROVED: 'APPROVED',
		PRE_APPROVED: 'PREV_APPROVED'
	};

	public static readonly BENCHMARK_TYPES = {
		DEFAULT: 'benchmark'
	};

	public static readonly SECURITY_DETAILS = 'security-details';
	public static readonly SECURITY_DETAILS_COMPARE = 'security-details-compare';
	public static readonly SECURITY_DETAILS_TAX = 'security-details-tax';
	public static readonly SECURITY_DETAILS_BLK_IDEAS = 'security-details-blk-ideas';

	public static readonly PAC_PORTFOLIO_ANALYSIS_RCS = {
		details: DataServiceApiUtil.createPacRcsPath(NileRcs.DETAILS),
		performance: DataServiceApiUtil.createPacRcsPath(NileRcs.PERFORMANCE),
		risk: DataServiceApiUtil.createPacRcsPath(NileRcs.RISK),
		'correlation-matrix': DataServiceApiUtil.createPacRcsPath(NileRcs.CORRELATION_MATRIX),
		'security-details': DataServiceApiUtil.createPacRcsPath(NileRcs.SECURITY_DETAILS)
	};

	public static readonly PC_PORTFOLIO_ANALYSIS_RCS = {
		details: DataServiceApiUtil.createPcRcsPath(NileRcs.DETAILS),
		performance: DataServiceApiUtil.createPcRcsPath(NileRcs.PERFORMANCE),
		risk: DataServiceApiUtil.createPcRcsPath(NileRcs.RISK),
		'correlation-matrix': DataServiceApiUtil.createPcRcsPath(NileRcs.CORRELATION_MATRIX),
		'security-details': DataServiceApiUtil.createPcRcsPath(NileRcs.SECURITY_DETAILS)
	};

	public static readonly CMA_PORTFOLIO_ANALYSIS_RCS = {
		wealthProjections: DataServiceApiUtil.createAcRcsPath(CmaRcs.WEALTH_PROJECTIONS),
		'security-details': DataServiceApiUtil.createAcRcsPath(PaRcs.SECURITY_DETAILS)
	};

	public static readonly PORTFOLIO_ANALYSER_RCS = {
		esg: DataServiceApiUtil.createAcRcsPath(PaRcs.ESG),
		risk: DataServiceApiUtil.createAcRcsPath(PaRcs.RISK),
		performance: DataServiceApiUtil.createAcRcsPath(PaRcs.PERFORMANCE),
		details: DataServiceApiUtil.createAcRcsPath(PaRcs.DETAILS),
		'security-details': DataServiceApiUtil.createAcRcsPath(PaRcs.SECURITY_DETAILS),
		'security-details-tax': DataServiceApiUtil.createAcRcsPath(SharedRcs.TAX_DETAILS)
	};

	public static readonly TAX_ESTIMATOR_RCS = {
		'security-details-tax': DataServiceApiUtil.createAcRcsPath(SharedRcs.TAX_DETAILS),
		'security-details-blk-ideas': DataServiceApiUtil.createAcRcsPath(TaxRcs.SECURITY_DETAILS_BLK_IDEAS),
		'security-details': DataServiceApiUtil.createAcRcsPath(TaxRcs.SECURITY_DETAILS)
	};

	public static readonly INVESTMENT_QUALITY_RCS = {
		details: DataServiceApiUtil.createAcRcsPath(IqRcs.DETAILS),
		'security-details': DataServiceApiUtil.createAcRcsPath(IqRcs.SECURITY_DETAILS),
		'security-details-compare': DataServiceApiUtil.createAcRcsPath(IqRcs.SECURITY_DETAILS_COMPARE),
		'fundAnalytics': DataServiceApiUtil.createAcRcsPath(IqRcs.FUND_ANALYTICS),
		'security-details-tax': DataServiceApiUtil.createAcRcsPath(SharedRcs.TAX_DETAILS)
	};

	public static readonly PROFESSIONAL_INVESTORS_RCS = {
		'security-details': DataServiceApiUtil.createAcRcsPath(PiRcs.SECURITY_DETAILS),
		details: DataServiceApiUtil.createAcRcsPath(PiRcs.DETAILS),
		performance: DataServiceApiUtil.createAcRcsPath(PiRcs.PERFORMANCE),
		risk: DataServiceApiUtil.createAcRcsPath(PiRcs.RISK)
	};

	public static readonly AC_PORTFOLIO_LIBRARY_RCS = {
		'security-details': DataServiceApiUtil.createAcRcsPath(AcPortfolioLibraryRcs.SECURITY_DETAILS),
		'security-details-tax': DataServiceApiUtil.createAcRcsPath(SharedRcs.TAX_DETAILS),
		details: DataServiceApiUtil.createAcRcsPath(AcPortfolioLibraryRcs.DETAILS),
		performance: DataServiceApiUtil.createAcRcsPath(AcPortfolioLibraryRcs.PERFORMANCE),
		risk: DataServiceApiUtil.createAcRcsPath(AcPortfolioLibraryRcs.RISK),
		rules: DataServiceApiUtil.createAcRcsPath(AcPortfolioLibraryRcs.RULES)
	};

	// todo wkennerl: update type with app name
	public static readonly WWE_RCS = {
		'portfolio-analysis-construction': { ...DataServiceApiConstants.PAC_PORTFOLIO_ANALYSIS_RCS },
		'portfolio-centre': { ...DataServiceApiConstants.PC_PORTFOLIO_ANALYSIS_RCS },
		'portfolio-centre-360': { ...DataServiceApiConstants.PC_PORTFOLIO_ANALYSIS_RCS },
		'cma-estimator': { ...DataServiceApiConstants.CMA_PORTFOLIO_ANALYSIS_RCS },
		'portfolio-analyser': { ...DataServiceApiConstants.PORTFOLIO_ANALYSER_RCS },
		'investment-quality': { ...DataServiceApiConstants.INVESTMENT_QUALITY_RCS },
		'professional-investors': { ...DataServiceApiConstants.PROFESSIONAL_INVESTORS_RCS },
		'ac-portfolio-library': { ...DataServiceApiConstants.AC_PORTFOLIO_LIBRARY_RCS },
		'tax-estimator': { ...DataServiceApiConstants.TAX_ESTIMATOR_RCS }
	};

	public static readonly PORTFOLIO_ANALYSIS_RCS = {
		details: 'bfa:portfolio-analyser',
		risk: 'bfa:portfolio-analyser-risk',
		performance: 'bfa:portfolio-analyser-performance', // Use only this for performance
		netPerformance: 'bfa:portfolio-analyser-net-performance', // Use only this for netPerformance
		netCustomPerformance: 'bfa:portfolio-analyser-net-performance', // Use only this for net performance when user provides custom advisory fee
		performanceCommonPeriods: 'bfa:portfolio-analyser-performance', // This is for performance when comparing portfolios and we need to use common periods
		netPerformanceCommonPeriods: 'bfa:portfolio-analyser-net-performance', // This is for net performance when comparing portfolios and we need to use common periods
		netCustomPerformanceCommonPeriods: 'bfa:portfolio-analyser-net-performance', // This is for net performance when user provides custom advisory fee and comparing portfolios and we need to use common periods
		scenarioTesterDetails: 'bfa:portfolio-analyser',
		portfolioImpact: 'bfa:portfolio-analyser-impact',
		mbDetails: 'bfa:mval:portfolio-analyser,bfa:products-us'
	};

	public static readonly PORTFOLIO_ANALYSIS_SLEEVE_RCS_SUFFIX = '-sleeve';
	public static readonly PORTFOLIO_ANALYSIS_SIMPLE_RCS_SUFFIX = '-simple';

	public static readonly STORES = {
		ASSOCIATED_PORTFOLIOS: 'associatedPortfolios',
		DETAILS: 'details',
		FUNDS_TO_EXPLORE: 'fundsToExplore',
		PERFORMANCE: 'performance',
		NET_PERFORMANCE: 'netPerformance',
		NET_CUSTOM_PERFORMANCE: 'netCustomPerformance',
		PERFORMANCE_COMMON_PERIODS: 'performanceCommonPeriods',
		NET_PERFORMANCE_COMMON_PERIODS: 'netPerformanceCommonPeriods',
		NET_CUSTOM_PERFORMANCE_COMMON_PERIODS: 'netCustomPerformanceCommonPeriods',
		RISK: 'risk',
		PORTFOLIO_IMPACT: 'portfolioImpact',
		MB_DETAILS: 'mbDetails',
		POSITION_DETAILS: 'positionDetails'
	};

	public static readonly STORES_PREFIXES = {
		APPROVED_PREFIX: 'approved-',
		LATEST_PREFIX: 'latest-',
		REBALANCE_PREFIX: 'rebalance-'
	};

	public static readonly FTE_TRANSITION_ID = 'fte-transition';

	public static readonly IDENTIFIER_TYPES = {
		SECURITY: 'SECURITY_ID'
	};

	public static readonly TAX_ESTIMATES_MAPPING = {
		'Active': null,
		'Pending': 'CAP_GAINS_STATUS_PENDING',
		'Not Distributing': 'CAP_GAINS_STATUS_NOT_EXPECTED',
		'Distributed': 'CAP_GAINS_STATUS_PASSED',
		'Not Tracked': 'CAP_GAINS_STATUS_NOT_TRACKED'
	};
}
